import React from 'react'
import ReactGA from 'react-ga'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import BackButton from '../components/backButton'
import CovidInfo from '../components/covidInfo'
import Footer from '../components/footer'
import ImportantInfo from '../components/importantInfo'
import Loading from '../components/loading'
import NavBar from '../components/navbar'
import ResultsBox from '../components/resultsBox'
import UserCard from '../components/usercard'
import TermsOfUseLink from '../components/termsOfUseLink'

class MainScreen extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: true,
            modalOpenTime: 0
        }
    }

    componentDidMount() {
        if (this.props.labResults === null) {
            // Not hooked up to a real api so commented out
            //this.props.dispatch(fetchLabResultsThunk());
        }
        if(this.state.showModal){
            var d = new Date();
            this.setState({modalOpenTime: d.getTime()})
        }
    }

    componentDidUpdate(prevProps, prevState){
      if(this.props.isLoggingOut!==true && (prevProps.user.name !== this.props.user.name)){
        console.log("Old:\t",prevProps.name);
        console.log("New:\t",this.props.user.name);
      }
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      }

    recordModalViewTime(){
        var modalCloseTime = new Date();
        var modalViewTime =  modalCloseTime.getTime() - this.state.modalOpenTime;
        
        console.log('Modal was open: ' +  modalViewTime + 'ms');
        ReactGA.event({
            category: 'User timing',
            action: 'Time spent on popup (ms)',
            label: this.uuidv4(),
            value: modalViewTime
          });
    }

    renderUser() {
        if (this.props.user == null) {
            return null;
        } else {
            return <UserCard user={this.props.user} language={this.props.language}/>
        }
    }

    render() {
        if (this.props.isError === true) {
            return <Redirect to="error" />
        }
        // FIXME Remove fake login!!!
        if (this.props.isLoggedIn !== true && this.props.isFakeLoggedIn !== true && this.props.isLoggingOut !== true) {
            return <Redirect to="/" />
        }
        if (this.props.isLoadingLogin === true || this.props.isLoadingLabResults === true || this.props.isLoggingOut === true){
            return <Loading />
        }
        // HTML here with bootstrap styles..
        return (
          <div className="container-full">
            <NavBar language={this.props.language}/>
            <div className="container">
              <div className="col" id="first">
                <div className="row">
                  <div className="d-inline d-lg-none">
                    <BackButton />
                  </div>
                  <div className="col-12 col-lg-4 col-md-12 order-1 order-sm-1 order-md-1 order-lg-2">
                    {this.renderUser()}
                    <TermsOfUseLink />
                    <ImportantInfo isModal={false} isResults={false} />
                  </div>
                  <ResultsBox />
                </div>
                <div class="alert alert-info hideDT" role="alert">
                  <CovidInfo />
                </div>
              </div>
            </div>
            <Footer />
          </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        isLoadingLabResults: state.api.isLoadingLabResults,
        isLoadingUsers: state.api.isLoadingUsers,
        user: state.api.user,
        labResults: state.api.labResults,
        strings: state.language.strings,
        language: state.language.language,
        isLoggedIn: state.auth.isLoggedIn,
        isFakeLoggedIn: state.auth.isFakeLoggedIn,
        isError: state.api.isError,
        isLoggingOut: state.auth.isLoggingOut,
    }
}

const ConnectedMainScreen = connect(
    mapStateToProps
)(MainScreen);
export default ConnectedMainScreen;
